import Components from "slotworks/components/components";
import {ButtonEvent} from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import CancelAutoButtonBehaviour from "slotworks/smart-button/behaviours/cancel-auto-button-behaviour";
import DisabledButtonBehaviour from "slotworks/smart-button/behaviours/disabled-spin-button-behaviour";
import FreespinButtonBehaviour from "slotworks/smart-button/behaviours/freespin-button-behaviour";
import SmartButton, {SmartButtonFlag} from "slotworks/smart-button/smart-button";
import {formatMoney} from "slotworks/utils/string-formatters";
import HiddenButtonBehaviour from "slotworks/smart-button/behaviours/hidden-button-behaviour";
import DisabledSpinButtonBehaviour from "slotworks/smart-button/behaviours/disabled-spin-button-behaviour";
import PromoFreespinDisabledButtonBehaviour from "slotworks/smart-button/behaviours/promo-fs-disabled-button-behaviour";
import PromoFreespinStartButtonBehaviour from "slotworks/smart-button/behaviours/promo-fs-start-button-behaviour";
import PromoFreespinStopButtonBehaviour from "slotworks/smart-button/behaviours/promo-fs-stop-button-behaviour";
import deviceInfo from "slotworks/utils/device-info";

export default class PromoBetBarComponent {
    private static TOTAL_WIN_VALUE: string = "total_win_value";
    private static TOTAL_WIN_TITLE: string = "total_win_label";
    private static SPINS_LEFT_VALUE: string = "spins_left_value";
    private static SPINS_LEFT_TITLE: string = "spins_left_label";
    private static BUTTON_INFO: string = "info_prompt";
    private static BUTTON_EXIT: string = "exit";

    private totalWin: FlexiText;
    private remainingSpins: FlexiText;
    private totalWinTitle: FlexiText;
    private remainingSpinsTitle: FlexiText;

    private exitButton: FlexiButton;
    private infoButton: FlexiButton;

    public constructor() {
        this.setupListeners();
    }

    public exit = () => {
        Layers.PromoBetBar.clear();
        Layers.PromoBetBar.defaultScene().execute();
    //    Layers.PromoBetBar.container.destroy();
        Layers.PromoBetBar.hide();
        Layers.PromoPopups.hide();

        CampaignsModel.clear();
        Layers.BetBar.show();
        this.destroy();
        
        this.disablePromoUI();

        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, false);
        SmartButton.setFlag(SmartButtonFlag.IDLE, true);
    };

    public destroy = () => {
        this.exitButton.off(ButtonEvent.POINTER_UP, this.exit);
        this.infoButton.off(ButtonEvent.POINTER_UP, this.showInfo);

        if (this.totalWin) {
            this.totalWin.destroy();
        }
        if (this.totalWinTitle) {
            this.totalWinTitle.destroy();
        }
        if (this.remainingSpins) {
            this.remainingSpins.destroy();
        }
        if (this.remainingSpinsTitle) {
            this.remainingSpinsTitle.destroy();
        }
        if (this.infoButton) {
            this.infoButton.destroy();
        }
        if (this.exitButton) {
            this.exitButton.destroy();
        }
    }

    public setTotalWin(value: number) {
        this.totalWin.setText(formatMoney(value));
    }

    public setRemainingSpins(remaining: number, total: number) {
        this.remainingSpins.setText(`${remaining}/${total}`);
    }

    public setEnabled(enable: boolean) {
        if (this.infoButton) {
            this.infoButton.setEnabled(enable);
        }
        if (this.exitButton) {
            this.exitButton.setEnabled(enable);
        }
    }

    public disablePromoUI() {
        const mobile = deviceInfo.layoutId === "mobile";

        for (let mask = 0; mask < SmartButtonFlag.MAX; mask++) {
            if ((mask & SmartButtonFlag.FREE_SPINS) > 0) {
                SmartButton.overrideBehaviour(mask, FreespinButtonBehaviour);
            }            
            if ((mask & SmartButtonFlag.AWAITING_RESPONSE) > 0) {
                SmartButton.overrideBehaviour(mask, DisabledButtonBehaviour);
            }
            if ((mask & SmartButtonFlag.PROMPT) > 0) {
                if ((mask & SmartButtonFlag.FREE_SPINS) > 0 || mobile) {
                    SmartButton.overrideBehaviour(mask, HiddenButtonBehaviour);
                } else {
                    SmartButton.overrideBehaviour(mask, DisabledSpinButtonBehaviour);
                }
            }
            if ((mask & SmartButtonFlag.BONUS) > 0 && mobile) {
                SmartButton.overrideBehaviour(mask, HiddenButtonBehaviour);
            }
            if((mask & SmartButtonFlag.AUTO_SPIN) > 0)
            {
                SmartButton.overrideBehaviour(mask, CancelAutoButtonBehaviour);
            }
        }
        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, false);
    }

    public enablePromoUI() {
        for (let mask = 0; mask < SmartButtonFlag.MAX; mask++) {
            if((mask & SmartButtonFlag.FREE_SPINS) > 0)
            {
                SmartButton.overrideBehaviour(mask, PromoFreespinStartButtonBehaviour);
            }
            if((mask & SmartButtonFlag.AUTO_SPIN) > 0)
            {
                SmartButton.overrideBehaviour(mask, PromoFreespinStopButtonBehaviour);
            }
            if((mask & SmartButtonFlag.AWAITING_RESPONSE) > 0)
            {
                SmartButton.overrideBehaviour(mask, PromoFreespinDisabledButtonBehaviour);
            }
        }
    }

    private setupListeners() {
        this.totalWin = Layers.PromoBetBar.getFlexiText(PromoBetBarComponent.TOTAL_WIN_VALUE);
        this.totalWinTitle = Layers.PromoBetBar.getFlexiText(PromoBetBarComponent.TOTAL_WIN_TITLE);
        let money = formatMoney(CampaignsModel.freespins.totalWin);
        this.totalWin.setText(money);

        this.remainingSpins = Layers.PromoBetBar.getFlexiText(PromoBetBarComponent.SPINS_LEFT_VALUE);
        this.remainingSpinsTitle = Layers.PromoBetBar.getFlexiText(PromoBetBarComponent.SPINS_LEFT_TITLE);
        let remaining = `${CampaignsModel.freespins.remaining}/${CampaignsModel.freespins.total}`
        this.remainingSpins.setText(remaining);

        this.infoButton = Layers.PromoBetBar.getFlexiButton(PromoBetBarComponent.BUTTON_INFO);
        this.infoButton.on(ButtonEvent.POINTER_UP, this.showInfo);
        this.exitButton = Layers.PromoBetBar.getFlexiButton(PromoBetBarComponent.BUTTON_EXIT);
        this.exitButton.on(ButtonEvent.POINTER_UP, this.exit);
    }

    private showInfo() {
        Components.promoPopups.get("help").show();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/promo-betbar/promo-bet-bar-component.ts